/* AE CRO batch 1 (1 Oct 2026)
   "Find your size" placeholder: the link is drawn by CSS from the first paint (ae-cro.css). EasySize's
   script arrives a few seconds later and its own button replaces the placeholder (ae-custom.js moves it
   into the same slot). A tap before then waits for EasySize and opens the quiz; if EasySize never
   loads, the size guide opens instead. */
(function () {
  var SLOT = '.product-details .fit-quiz-wrapper .easysize-container';

  function prepare() {
    document.querySelectorAll(SLOT).forEach(function (c) {
      if (c.dataset.aeFit) return;
      c.dataset.aeFit = '1';
      if (!c.firstElementChild) { c.setAttribute('role', 'button'); c.setAttribute('tabindex', '0'); c.setAttribute('aria-label', 'Find your size'); }
      new MutationObserver(function () {
        if (c.querySelector('#easysize_button')) { c.removeAttribute('role'); c.removeAttribute('tabindex'); c.removeAttribute('aria-label'); c.classList.remove('ae-fit-waiting'); }
      }).observe(c, { childList: true });
    });
  }

  function openFit(c) {
    if (c.classList.contains('ae-fit-waiting')) return;
    c.classList.add('ae-fit-waiting');
    var started = Date.now();
    (function tryOpen() {
      var btn = document.querySelector('.product-details #easysize_button') || document.querySelector('#easysize_button');
      if (btn) { c.classList.remove('ae-fit-waiting'); btn.click(); return; }
      if (Date.now() - started < 8000) { setTimeout(tryOpen, 200); return; }
      c.classList.remove('ae-fit-waiting');
      var group = c.closest('.group-block-content');
      var guide = group && group.querySelector('.popup-link button, .popup-link a, button[class*="popup"], a[class*="popup"]');
      if (guide) guide.click();
    })();
  }

  document.addEventListener('click', function (e) {
    var c = e.target instanceof Element && e.target.closest(SLOT);
    if (!c || c.querySelector('#easysize_button')) return;
    e.preventDefault();
    openFit(c);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target instanceof Element && e.target.matches(SLOT) ? e.target : null;
    if (!c || c.querySelector('#easysize_button')) return;
    e.preventDefault();
    openFit(c);
  });

  // Products EasySize doesn't support never get a button: drop the placeholder after 15s.
  setTimeout(function () {
    document.querySelectorAll(SLOT).forEach(function (c) {
      if (!c.firstElementChild && !c.classList.contains('ae-fit-waiting')) {
        c.classList.add('ae-fit-none'); c.removeAttribute('role'); c.removeAttribute('tabindex'); c.removeAttribute('aria-label');
      }
    });
  }, 15000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare); else prepare();
})();

/* Newsletter popup (Shopify Forms) waits until the cookie banner has been answered, so shoppers
   only face one overlay at a time. Visitors who never see a banner (no consent needed, or already
   answered) get the popup as normal. If the banner hasn't appeared within 5 s, nothing is held. */
(function () {
  var root = document.documentElement;
  root.classList.add('ae-hold-popup');
  var released = false, seen = false, started = Date.now();
  function release(delay) {
    if (released) return; released = true;
    setTimeout(function () { root.classList.remove('ae-hold-popup'); }, delay || 0);
  }
  function bannerOpen() {
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && b.offsetHeight > 0 && getComputedStyle(b).display !== 'none');
  }
  (function tick() {
    if (released) return;
    if (bannerOpen()) { seen = true; setTimeout(tick, 400); return; }
    if (seen) { release(1500); return; }                 // banner was answered
    if (Date.now() - started < 5000) { setTimeout(tick, 250); return; }
    release(0);                                          // no banner on this visit
  })();
  document.addEventListener('visitorConsentCollected', function () { release(1500); });
})();
